if (!global._babelPolyfill) {
    require('babel-polyfill');
}

require(
    __dirname + "/main.scss"
);

import(__dirname + "/patterns/fm-contentmap/scripts/cookie.js");
import(__dirname + "/patterns/fm-contentmap/fm-contentmap.js");